import React from 'react'
import styled from 'styled-components'

import { IconButton } from '@mui/material'
import { ComponentStyleSheet } from '@nexiahome/ui-common/themes'
import { Button, ButtonTheme } from '@nexiahome/ui-common/components/primitives/buttons'

import ConversationList from 'components/Chatbot/ConversationList'

import { GroupedConversations } from 'types/Chat'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

interface ConversationSidebarProps {
  isSidebarCollapsed: boolean
  handleToggleSidebar: () => void
  conversationIdFromUrl: string | null
  groupedConversations: GroupedConversations
  loading: boolean
  loadingMore: boolean
  nextToken: string | null
  error: string | null
  listConversations: (token?: string | null, append?: boolean) => Promise<void>
  onSelectConversation: (id: string) => void
  onDeleteConversation: (id: string) => Promise<void>
  openNewChat: () => void
}

const ConversationSidebar = ({
  isSidebarCollapsed,
  handleToggleSidebar,
  conversationIdFromUrl,
  groupedConversations,
  loading,
  loadingMore,
  nextToken,
  error,
  listConversations,
  onSelectConversation,
  onDeleteConversation,
  openNewChat
}: ConversationSidebarProps) => {
  return (
    <S.PreviousHistory $collapsed={isSidebarCollapsed}>
      <S.HeaderText $collapsed={isSidebarCollapsed}>
        {!isSidebarCollapsed && <span>AI Chat</span>}
        <IconButton onClick={handleToggleSidebar}>
          <img src="/img/expand_collapse_icon.svg" alt="AI Chat" />
        </IconButton>
      </S.HeaderText>
      <S.ChatList $collapsed={isSidebarCollapsed}>
        <ConversationList
            selectedConversationId={conversationIdFromUrl}
            groupedConversations={groupedConversations}
            loading={loading}
            loadingMore={loadingMore}
            nextToken={nextToken}
            error={error}
            listConversationsCallback={listConversations}
            onSelectConversation={(id) => { onSelectConversation(id) }}
            onDeleteConversation={onDeleteConversation}
        />
      </S.ChatList>
      <Button icon="new" styles={isSidebarCollapsed ? NewChatIconsStyle : NewChatButtonStyle} decoration="positive" text={isSidebarCollapsed ? '' : 'New Chat'} onPress={() => openNewChat()} />
    </S.PreviousHistory>
  )
}

const NewChatButtonStyle: ComponentStyleSheet<ButtonTheme> = {
  button: {
    height: 36,
    borderRadius: 15,
    margin: 'auto',
    position: 'absolute',
    bottom: 20
  }
}
const NewChatIconsStyle: ComponentStyleSheet<ButtonTheme> = {
  button: {
    height: 36,
    minWidth: 34,
    borderRadius: 50,
    position: 'absolute',
    bottom: 20
  },
  iconContainer: {
    marginRight: 0
  }
}

export default ConversationSidebar

const S = {
  ChatList: styled.div<{ $collapsed: boolean }>`
    display: ${({ $collapsed }) => ($collapsed ? 'none' : 'block')};
    transition: all 0.3s ease;
  `,
  PreviousHistory: styled.div<{ $collapsed: boolean }>`
    width: ${({ $collapsed }) => ($collapsed ? 'auto' : undefined)};
    background: ${color('chatbotHistoryBackground')};
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    padding: ${({ $collapsed }) => ($collapsed ? '48px 8px 70px 8px' : '48px 16px 70px 16px')};
    transition: all 0.3s ease;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    button{
      bottom: 10% !important;
      div{
        text-transform: capitalize !important;
      }
    }

    @media (${screenSize.small}) {
      ${({ $collapsed }) => !$collapsed && `
        position: absolute;
        top: 3%;
        left: 0;
        bottom: 0;
        z-index: 10;
        width: 60%;
        height: 87vh;
      `}
    }
  `,
  HeaderText: styled.div<{ $collapsed: boolean }>`
    display: flex;
    justify-content: ${({ $collapsed }) => ($collapsed ? 'center' : 'space-between')};
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 28px;
    color: ${color('chatbotText')};
    align-items: center;

    @media (${screenSize.medium}) {
      font-size: 18px;
      margin-bottom: -6px;
    }
  `
}
